angular.module('bmsApp.settings').factory('SalesTypeSvc', function ($http, $log, $window, $q, CRUDSvc, SALES_TYPE_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(SALES_TYPE_API.INDEX, params);
		},
		update: function (data) {
			return CRUDSvc.post(SALES_TYPE_API.UPDATE, data);
		}
	}

}).constant('SALES_TYPE_API', {
	INDEX: 'api/settings/salesTypes/index',
	UPDATE: 'api/settings/salesType/update'
});




